<div class="card selectContainer m-auto align-middle p-3">
  <div class="card-header d-flex justify-content-between">
    <h1>Select Character</h1>
    <button class="btn btn-sm btn-main text-white" (click)="addCharacter()">New Character</button>
  </div>
  <div class="card-body overflow-auto custom-scrollbar">
    <div *ngIf="user.characters.length === 0" class="card">
      <h2 class="m-0">No Characters</h2>
      <h5 class="text-muted m-0">Create one</h5>
    </div>
    <div *ngIf="user.characters.length > 0" class="d-flex justify-content-start flex-wrap py-0 px-2">
    <div class="card character-card characterBorder mx-2 my-2" *ngFor="let character of user.characters"
         (click)="selectCharacter(character)">
      <div class="mx-auto my-auto text-center">{{character}}</div>
    </div>
  </div>
  </div>
</div>
